import * as React from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import useLocation from "routing/useLocation";
import useIsInvestigationAIReportEnabled from "security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled";
import AIReportButton from "security-app/components/Investigations/AIReport/AIReportButton";
import InvestigationMoreActionsMenu from "./InvestigationMoreActionsMenu";
import useInvestigationPanel from "./hooks/useInvestigationPanel";
const Wrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.spacings.xs};
  `
);
function RowActionMenu({
  investigation,
  onDelete: onDeleteProp = void 0,
  onArchive: onArchiveProp = void 0
}) {
  var _a;
  const isAIReportFeatureEnabled = useIsInvestigationAIReportEnabled();
  const { selectedInvestigationId, setSelectedInvestigationId } = useInvestigationPanel();
  const { pathname } = useLocation();
  const isArchived = pathname.endsWith("investigations/archived");
  return /* @__PURE__ */ React.createElement(Wrapper, null, isAIReportFeatureEnabled && /* @__PURE__ */ React.createElement(AIReportButton, { investigation, logsCount: (_a = investigation == null ? void 0 : investigation.evidence_counts) == null ? void 0 : _a.logs }), !isArchived && investigation.id !== selectedInvestigationId && /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: () => setSelectedInvestigationId(investigation.id, true),
      title: `Set investigation ${investigation.name} as active`
    },
    "Set as active"
  ), /* @__PURE__ */ React.createElement(
    InvestigationMoreActionsMenu,
    {
      investigation,
      isArchived,
      onDelete: onDeleteProp,
      onArchive: onArchiveProp
    }
  ));
}
export default RowActionMenu;
